import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {fetchApiResponseVideo } from "Config/fetchApi";
import { handleError } from "Helper";

// Initial state
const initialState = {
  videoResponse: {
    datavideoResponse: [],
    isLoadingvideoResponse: false,
    errorvideoResponse: null,
    videoDetails: [], // untuk menyimpan data video lainnya
    isLoadingvideoDetails: false,
    errorvideoDetails: null,
  },
};


// Thunk action for fetching IP Cam Response
export const getvideoResponse = createAsyncThunk(
  "video/getvideoResponse",
  async ({ path, json } = {}, { rejectWithValue }) => {
    try {
      const api = fetchApiResponseVideo();
      const url = `${path}/${json}`;
      const result = await api(url, { method: "GET" });
      // console.log(result, "results");
      return result[0]?.data || [];
    } catch (error) {
      handleError(error);
      console.error(error);
      return rejectWithValue(error?.message || "An error occurred");
    }
  }
);
// Thunk action baru untuk mendapatkan detail video
export const getVideoDetails = createAsyncThunk(
  "video/getVideoDetails",
  async (_, { rejectWithValue }) => {
    try {
      const api = fetchApiResponseVideo();
      const url = "";
      const result = await api(url, { method: "GET" });
      // console.log(result, 'ress')
      return result;
    } catch (error) {
      handleError(error);
      console.error(error);
      return rejectWithValue(error?.message || "An error occurred");
    }
  }
);

// Slice definition
const videoResponseSlice = createSlice({
  name: "videoReponse",
  initialState,
  reducers: {
    clearVideoResponse: (state) => {
      state.videoResponse.datavideoResponse = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getvideoResponse.pending, (state) => {
        state.videoResponse.isLoadingvideoResponse = true;
        state.videoResponse.errorvideoResponse = null;
      })
      .addCase(getvideoResponse.fulfilled, (state, action) => {
        state.videoResponse.isLoadingvideoResponse = false;
        state.videoResponse.datavideoResponse = action.payload || [];
        state.videoResponse.errorvideoResponse = null;
      })
      .addCase(getvideoResponse.rejected, (state, action) => {
        state.videoResponse.isLoadingvideoResponse = false;
        state.videoResponse.errorvideoResponse = action.payload;
      });
    builder
      .addCase(getVideoDetails.pending, (state) => {
        state.videoResponse.isLoadingvideoDetails = true;
        state.videoResponse.errorvideoDetails = null;
      })
      .addCase(getVideoDetails.fulfilled, (state, action) => {
        state.videoResponse.isLoadingvideoDetails = false;
        state.videoResponse.videoDetails = action.payload || [];
        state.videoResponse.errorvideoDetails = null;
      })
      .addCase(getVideoDetails.rejected, (state, action) => {
        state.videoResponse.isLoadingvideoDetails = false;
        state.videoResponse.errorvideoDetails = action.payload;
      });
  },
});

export const { clearVideoResponse } = videoResponseSlice.actions;
export default videoResponseSlice.reducer;
